angular.module('cian.serp')
  .directive('compileHtmlContent', ["$compile", "$log", function ($compile, $log) {
    return {
      // TODO add $destroy call
      restrict: 'A',
      link: function (scope, element, attrs) {
        scope.$watch(function () {
          return scope.$eval(attrs.compileHtmlContent);
        }, function (newValue) {
          if (newValue) {
            element[0].innerHTML = newValue;

            // Выполняем скрипты, зашитые в выдачу:
            // рекламные баннеры, ипотека
            var scripts = element[0].getElementsByTagName('script');
            for (var i = 0; i < scripts.length; i++) {
              var script = scripts[i].innerHTML;
              try {
                eval(script);
              } catch (e) {
                $log.error(e);
                window.Raven.captureException(e, {
                  extra: { script: script.slice(0, 1000) }
                });
              }
            }

            $compile(element.contents())(scope);

            if (attrs.onComplete) scope.$eval(attrs.onComplete);
          }
        });
      }
    };
  }]);



//////////////////
// WEBPACK FOOTER
// ../components/serp/src/scripts/cian.serp.compileHtmlContent.js
// module id = 489
// module chunks = 0